// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonShow_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.99998 8C7.10455 8 7.99998 7.10457 7.99998 6C7.99998 4.89543 7.10455 4 5.99998 4C4.89541 4 3.99998 4.89543 3.99998 6C3.99998 7.10457 4.89541 8 5.99998 8Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99994 10C8.7957 10 11.3339 8.3003 12 6C11.3339 3.6997 8.7957 2 5.99994 2C3.20418 2 0.666064 3.6997 0 6C0.666064 8.3003 3.20418 10 5.99994 10ZM5.99994 9C3.68095 9 1.69624 7.66062 1.05448 6C1.69624 4.33938 3.68095 3 5.99994 3C8.31894 3 10.3038 4.3394 10.9455 6C10.3038 7.6606 8.31894 9 5.99994 9Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C9.65685 5 11 6.34315 11 8ZM9 8C9 8.55228 8.55228 9 8 9C7.44772 9 7 8.55228 7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 2C4.27224 2 0.888085 4.54955 0 8C0.888085 11.4505 4.27224 14 7.99992 14C11.7276 14 15.1119 11.4505 16 8C15.1119 4.54955 11.7276 2 7.99992 2ZM14 8C13.1763 5.66962 10.6124 4 7.99992 4C5.38748 4 2.82367 5.66962 2 8C2.82367 10.3304 5.38748 12 7.99992 12C10.6124 12 13.1763 10.3304 14 8Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 12C22.0415 7.3021 17.4062 4 12 4C6.59376 4 1.95852 7.3021 0 12C1.95852 16.6979 6.59424 20 12.0005 20C17.4067 20 22.0415 16.6979 24 12L21.7981 12C19.9779 15.5617 16.2739 18 12.0005 18C7.72711 18 4.02306 15.5617 2.20291 12C4.02306 8.43832 7.72662 6 12 6C16.2734 6 19.9779 8.43833 21.7981 12L24 12Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 16C14.2087 16 15.999 14.2091 15.999 12C15.999 9.79086 14.2087 8 12.0002 8C9.79177 8 8.00146 9.79086 8.00146 12C8.00146 14.2091 9.79177 16 12.0002 16ZM12.0002 14C13.1045 14 13.9996 13.1046 13.9996 12C13.9996 10.8954 13.1045 10 12.0002 10C10.896 10 10.0008 10.8954 10.0008 12C10.0008 13.1046 10.896 14 12.0002 14Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16ZM19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M32 16C29 24 22.0751 27 16 27C9.92487 27 3 24 0 16C3 8 9.92487 5 16 5C22.0751 5 29 8 32 16ZM29.5 16C27.0625 22.5 20.936 24.9375 16 24.9375C11.064 24.9375 4.9375 22.5 2.5 16C4.9375 9.5 11.064 7.0625 16 7.0625C20.936 7.0625 27.0625 9.5 29.5 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonShow is a generated icon component.
 */
let IconCommonShow = IconCommonShow_1 = class IconCommonShow extends IconBaseElement {
    render() {
        return html `${IconCommonShow_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonShow.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconCommonShow = IconCommonShow_1 = __decorate([
    customElement('zui-icon-common-show')
], IconCommonShow);
export { IconCommonShow };
